export default function setBodyColor({color}) {
    document.documentElement.style.setProperty('--main-blue', color)
    document.documentElement.style.setProperty('--primary-color', color)
    document.documentElement.style.setProperty('--light-blue', color)
    document.documentElement.style.setProperty('--dark-blue', color)
    document.documentElement.style.setProperty('--reverse-primary', color)
    document.documentElement.style.setProperty('--main-blue-transparent',color)
}